import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DateService {
    private months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];

    constructor() {
    }

    getCurrentFiscalYearDisplay(
        fiscalStartMonth: number
    ): string {
        const now = new Date();
        const startMonth = fiscalStartMonth - 1;
        let startYear = now.getFullYear() - 1;

        let endMonth = fiscalStartMonth - 2;

        if (now.getMonth() + 1 >= fiscalStartMonth) {
            startYear = now.getFullYear();
        }

        let endYear = startYear + 1;
        if (fiscalStartMonth === 1) {
            endMonth = 11;
            endYear = startYear;
        }

        return (
                this.months[startMonth] +
                ' ' +
                startYear +
                ' - ' +
                this.months[endMonth] +
                ' ' +
                endYear
        );
    }
}
